import { Component, OnInit } from '@angular/core';
import { ItemKpiService } from "../services/item-kpi.service";

@Component({
  selector: 'app-item-history',
  templateUrl: './item-history.component.html',
  styleUrls: ['./item-history.component.scss']
})
export class ItemHistoryComponent implements OnInit {
  itemHistory;
  epc: string = '';
  errorMessage: string = ''; // Add a variable to hold error message

  constructor(private itemHistoryService: ItemKpiService) { }

  ngOnInit(): void {
    this.onSearch();
  }

  onSearch(): void {
    console.log(this.epc);
    this.itemHistoryService.getEPCHistory(this.epc)
    // .subscribe(data => {
    //   if (data) {
    //     this.itemHistory = data['data'];
    //     this.errorMessage = ''; // Clear any previous error message
    //   } 
    // }, error => {
    //   this.itemHistory = null; // Clear previous results
    //   this.errorMessage = 'No item found with the provided EPC. Please check and try again.';
    // });
  } 
}
